var map = {
	"./AmiyaBagchi.jpg": 605,
	"./AmiyaBagchi.png": 606,
	"./ChinmayTumbe.png": 607,
	"./DavidArnold.jpg": 608,
	"./DavidArnold.png": 609,
	"./DouglasHaynes.jpg": 610,
	"./DouglasHaynes.png": 611,
	"./DwijendraTripathi.jpg": 612,
	"./DwijendraTripathi.png": 613,
	"./GeoffreyJones.png": 614,
	"./IndiraChowdhury.jpg": 615,
	"./IndiraChowdhury.png": 616,
	"./JosephSassoon.jpg": 617,
	"./JosephSassoon.png": 618,
	"./MedhaKudaisya.jpg": 619,
	"./MedhaKudaisya.png": 620,
	"./PrafullAnubhai.jpg": 621,
	"./PrafullAnubhai.png": 622,
	"./RamachandraGuha.png": 623,
	"./RituBirla.jpg": 624,
	"./RituBirla.png": 625,
	"./RobertPerks.png": 626,
	"./RossBassett.jpg": 627,
	"./RossBassett.png": 628,
	"./SvenBeckert.png": 629,
	"./SvenBeckertOld.png": 630,
	"./TirthankarRoy.jpg": 631,
	"./TirthankarRoy.png": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;